// Categorías de colisión (Bitmasks)
// Deben ser potencias de 2
export const COLLISION_CATEGORIES = {
    DEFAULT: 0x0001,      // Paredes, bordes (si hubiera físicos)
    BUBBLE: 0x0002,       // Burbujas sueltas
    CLUSTER: 0x0004,      // El cuerpo del cluster
    INNER_BUBBLE: 0x0008, // Burbujas dentro de un cluster
    MOUSE: 0x0010,        // El mouse (para poder agarrar cosas)
    WALL: 0x0020          // Paredes
};

// // Grupos de colisión
// // Si el grupo es negativo, los objetos del mismo grupo NO colisionan entre sí.
// // Si es positivo, SIEMPRE colisionan (sobrescribe categorías).
// export const COLLISION_GROUPS = {
//     CLUSTER_INTERNAL: -1 // util si las burbujas internas se ignorán (opcional)
// };

export const BUBBLE_MAX_RADIUS: number = 50; // Radio en pantallas grandes (tablet/desktop)
export const BUBBLE_MIN_RADIUS: number = 24; // Radio mínimo en pantallas muy chicas (celulares)

/** @deprecated Usar {@link _GetResponsiveBubbleRadius}. Se mantiene como valor de referencia/fallback. */
export const BUBBLE_DEFAULT_RADIUS: number = BUBBLE_MAX_RADIUS;

export const BUBBLE_SCALE_FACTOR = 0.5; // Factor de reducción al ser atrapada por un cluster